import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

export const ErrorPagePanel = styled('section')(({ theme }) => ({
  width: '100%',
  minHeight: 360,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(4, 2),
  textAlign: 'center',
  border: '1px solid rgba(173, 223, 255, 0.1)',
  background:
    'linear-gradient(180deg, rgba(14, 19, 25, 0.98) 0%, rgba(8, 12, 18, 1) 100%)',
  boxShadow: '0 22px 48px rgba(0, 0, 0, 0.22)',
}))

export const ErrorPageTitle = styled(Typography)(() => ({
  color: '#f6fbff',
  fontWeight: 800,
}))

export const ErrorPageDescription = styled(Typography)(() => ({
  color: 'rgba(230, 240, 250, 0.78)',
  maxWidth: 480,
}))
